import { KeyPerformance } from '../components/key-performance/key-performance.tsx'
import { useState } from 'react'
import { DashboardComponent } from './components/dashboard/dashboard-component.tsx'
import { isV2Ready } from '../../utils/helpers.ts'
import { DashboardUserControls } from './components/dashboard/dashboard-user-controls.tsx'
import { useAppSelector } from '../../redux/hooks.ts'
import { selectThemeStyle } from '../../features/setting/setting.slice.ts'

interface DashboardProps {
  bookId?: string
}

export const Dashboard: React.FC<DashboardProps> = ({ bookId }) => {
  const [showKeyPerformanceSection, setShowKeyPerformanceSection] =
    useState<boolean>(true)
  const themeStyle = useAppSelector(selectThemeStyle)

  return (
    <>
      <DashboardUserControls />
      <div style={{ marginBottom: themeStyle.marginSM }}>
        {isV2Ready && (
          <KeyPerformance
            taskCompletionRate={0.65}
            numOfPendingTasks={3}
            currentRanking={23}
            totalRankingAmount={100}
            currentPnl={12200234}
            topPnl={345678890}
            showKeyPerformanceSection={showKeyPerformanceSection}
            setShowKeyPerformanceSection={() =>
              setShowKeyPerformanceSection(!showKeyPerformanceSection)
            }
            canEdit={true}
            bookId={bookId}
          />
        )}
      </div>
      <DashboardComponent bookId={bookId} />
    </>
  )
}
